// Contexto para anmazenar o retorno da visualização das mensagens aos usuários

import React, { createContext, useState } from "react";

export const SnackBarContext = createContext()

export const SnackBarContextProvider = ({children}) => {
    const [snackBar, setSnackBarContext] = useState(false)

    return (
        <SnackBarContext.Provider value={{snackBar, setSnackBarContext}}>
            { children }
        </SnackBarContext.Provider>
    )
}